import { cn } from '@mntn-dev/ui-utilities'
import { type KeyboardEvent, forwardRef } from 'react'
import { type TestIds, getTestProps } from '../../utils'
import { useInputStyles } from './use-input-styles.ts'

export type DateInputProps = {
  date?: string
  time?: string
  hasError?: boolean
  disabled?: boolean
  onClick?: () => void
  onFocus?: () => void
  onKeyDown?: (e: KeyboardEvent<HTMLDivElement>) => void
} & TestIds

export const DateInput = forwardRef<HTMLDivElement, DateInputProps>(
  (
    {
      date,
      time,
      hasError,
      disabled,
      onClick,
      onFocus,
      onKeyDown,
      dataTestId,
      dataTrackingId,
    },
    ref
  ) => {
    const inputStyles = useInputStyles({ hasError, disabled })
    return (
      <div
        className="flex"
        {...getTestProps({ dataTestId, dataTrackingId })}
        ref={ref}
      >
        <div
          className={cn(
            inputStyles,
            'items-center w-full justify-between pr-12 cursor-pointer'
          )}
          tabIndex={0}
          // biome-ignore lint/a11y/useSemanticElements: fix
          role="textbox"
          aria-disabled={disabled}
          onClick={disabled ? undefined : onClick}
          onFocus={disabled ? undefined : onFocus}
          onKeyDown={disabled ? undefined : onKeyDown}
        >
          {date && <span>{date}</span>}
          {time && <span>{time}</span>}
        </div>
      </div>
    )
  }
)
